<template>
  <div class="agreement">
    <h1>个人信息授权协议</h1>
    <p>个人信息授权协议（以下简称“本协议”）是“豪享冲公司“(以下简称“我们”)与您就您的个人信息授权处理活动的协议约定，您的勾选、点击提交、使用等行为，即视为您已阅读并同意本协议的全部内容并愿意受本协议约束。</p>
    <p>为了保障您的合法权益，请您务必认真阅读并充分理解本协议，尤其是加粗的部分，如果您不同意本协议，请勿进行下一步操作。</p>

    <h2>一、您授权并同意我们收集和使用的个人信息的类型</h2>
    <p>为了向您提供门店入驻、门店服务、区县代理、电商供货等相关的合作招募服务，您需要在页面填写并提供的个人信息包括但不限于：</p>
    <ul>
      <li>（1）联系人真实姓名</li>
      <li>（2）联系人手机号</li>
      <li>（3）联系人职位</li>
      <li>（4）意向合作城市</li>
      <li>（5）其他选填信息(可自主决定是否填写)：现所在城市、证件号码以及基于您的意向需要提供的项目经历、人员经验等信息。</li>
    </ul>
    <p>以上个人信息均由您主动填写，如果您拒绝提供，我们将不再基于授权收集、使用您的相关个人信息，请您注意，拒绝后可能将无法继续使用该页面的服务产品功能和接收后续合作招募信息。</p>

    <h2>二、您授权并同意我们在以下场景收集和使用您的个人信息</h2>
    <ol>
      <li>为了保障招募安全的需要，您需要配合实名制认证，提供实名信息以便我们核验您的真实身份。</li>
      <li>为了方便您意向合作业务、城市及地点的对应豪享冲业务员能够正常联系到您，与您沟通您合作意向，安排沟通洽谈或签订合同等信息，您授权并同意我们收集并共享您的个人信息，以便您后期接收来自豪享冲的邀请或需求沟通，包含但不限于：合作内容介绍，邀请您了解合作业务相关信息、安排沟通洽谈或签订合作信息等。</li>
      <li>为了方便您获取与招募相关的活动信息或参与调研，您授权并同意我们收集并共享您的个人信息，用于我们向您提供服务邀请和/或回访。我们可能会通过电话、短信进行回访、或向您提供问卷调研等。如果您不同意接收相关信息推送，可以通过相应的退订方式进行退订，或者在电话回访中明确表示拒绝。</li>
      <li>为了向您提供更加优质的招募服务，我们可能将对提供服务过程中收集的个人信息采取技术措施和其他必要措施进行处理，在个人信息匿名化或已经去标识化无法识别您身份的前提下，将您提供的个人信息用于数据分析、建立用户数据库并加以商业化利用。</li>
    </ol>

    <h2>三、合法、正当、必要原则</h2>
    <p>我们将在合法、正当、必要的范围内收集、使用您的个人信息，并要求您授权的合作商在合法正当必要的范围内收集、使用您的个人信息，如我们超出与本协议所声称的目的收集、使用您的个人信息的，我们会再次向您告知并征得您的同意。</p>
    <p>我们会要求合作商对您的个人信息进行严格保密，要求其按照我们的说明以及其他任何相关的保密和安全措施来处理个人信息。</p>

    <h2>四、通知和修订</h2>
    <p>我们可能适时修改本协议，对于重大变更，我们会提供更显著的通知，您可以选择停止使用产品/服务；在该种情况下，如您仍然继续使用我们的产品/服务，即表示同意接受经修订的本协议的约束。</p>

    <p>以上内容您已经充分知悉，并自愿作出上述授权同意，本协议是您本人真实的意思表示，并同意承担由此带来的法律后果。</p>

    <div class="back">
      <router-link to="/">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Consent',
}
</script>

<style scoped>
.agreement {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px 16px;
  line-height: 1.8;
  color: #303133;
  background: #fff;
}
.agreement h1 {
  font-size: 20px;
  margin-bottom: 12px;
}
.agreement h2 {
  font-size: 16px;
  margin-top: 16px;
}
.agreement ul, .agreement ol {
  margin-left: 18px;
}
.back {
  margin-top: 24px;
}
.back a { color: #0CBE48; }

@media (max-width: 767px) {
  .agreement {
    padding: 16px 12px;
  }
}
</style>